'use client';

import { useRouter } from 'next/navigation';
import { Box, Button } from '@mui/material';

import { Dialog } from '~/shared';
import { type Advertiser } from '~/types';

export type AdvertiserNavigationModalProps = {
  advertiser: Advertiser | null;
  open: boolean;
  onClose: () => void;
};

export function AdvertiserNavigationModal({
  advertiser,
  open,
  onClose,
}: AdvertiserNavigationModalProps) {
  const router = useRouter();

  const handleNavigateToCampaigns = () => {
    if (advertiser) {
      router.push(`/campanhas?advertiserUrl=${advertiser.name}`);
      onClose();
    }
  };

  const handleNavigateToSponsoredProducts = () => {
    if (advertiser) {
      router.push(`/patrocinados?advertiserUrl=${advertiser.name}`);
      onClose();
    }
  };

  return (
    <Dialog
      title="Qual campanha você quer filtrar?"
      open={open}
      onClose={onClose}
      withCloseButton
      maxWidth="sm"
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Button
          onClick={handleNavigateToCampaigns}
          sx={{ px: 3, py: 2, textTransform: 'none' }}
          variant="contained"
          size="large"
          fullWidth
        >
          Banners
        </Button>

        <Button
          onClick={handleNavigateToSponsoredProducts}
          sx={{ px: 3, py: 2, textTransform: 'none' }}
          variant="outlined"
          size="large"
          fullWidth
        >
          Produtos Patrocinados
        </Button>

        <Button
          onClick={onClose}
          sx={{ px: 3, py: 1.5, mt: 1, textTransform: 'none' }}
          variant="text"
          size="small"
          fullWidth
        >
          Cancelar
        </Button>
      </Box>
    </Dialog>
  );
}
